/**
 * Suppress Inertia's built-in iframe modal for non-Inertia responses.
 *
 * When the server returns a non-Inertia response (e.g. a 403 or 500 HTML page),
 * Inertia core fires the cancelable `inertia:invalid` event and, if it is not
 * cancelled, tries to render the response body inside a freshly created iframe.
 * The iframe is inserted into the DOM and accessed synchronously in the same
 * tick, which means `iframe.contentWindow` is still null in some browsers,
 * causing an unhandled "iframe not yet ready" promise rejection.
 *
 * Cancelling the event prevents `modal_default.show()` from being called while
 * still allowing Sentry to capture the unexpected response.
 */
export function suppressInertiaInvalidModal(): void {
  document.addEventListener('inertia:invalid', (event) => {
    event.preventDefault();
  });
}
